import ReportedMarksCard from "./component";

export default ReportedMarksCard;
